import className, { USE_VALUE } from '@wavevision/class-name';

import { FlashMessageProps, FlashMessageState } from './types';

export const flashMessageClassName = className<
  FlashMessageProps,
  { visible: FlashMessageState }
>('flash-message', () => ({
  text: true,
  type: USE_VALUE,
  visible: true,
}));
